/**
 * Get appropriate icon/emoji for file type
 * @param {string} mimeType - MIME type of the file
 * @returns {string} Icon emoji or symbol
 */
export function getFileIcon(mimeType) {
  if (!mimeType) return '📄';
  
  if (mimeType.startsWith('image/')) return '🖼️';
  if (mimeType === 'application/pdf') return '📕';
  if (mimeType.startsWith('video/')) return '🎥';
  if (mimeType.startsWith('audio/')) return '🎵';
  if (mimeType.includes('word') || mimeType.includes('document')) return '📝';
  if (mimeType.includes('sheet') || mimeType.includes('excel')) return '📊';
  if (mimeType.includes('presentation') || mimeType.includes('powerpoint')) return '📽️';
  if (mimeType === 'application/zip' || mimeType.includes('compressed')) return '📦';
  if (mimeType === 'text/plain') return '📄';
  if (mimeType === 'text/csv') return '📋';
  
  return '📄';
}

/**
 * Get file type label for display
 * @param {string} mimeType - MIME type of the file
 * @returns {string} Human-readable file type
 */
export function getFileTypeLabel(mimeType) {
  if (!mimeType) return 'Unknown';
  
  if (mimeType.startsWith('image/')) return 'Image';
  if (mimeType === 'application/pdf') return 'PDF';
  if (mimeType.startsWith('video/')) return 'Video';
  if (mimeType.startsWith('audio/')) return 'Audio';
  if (mimeType.includes('word') || mimeType.includes('document')) return 'Document';
  if (mimeType.includes('sheet') || mimeType.includes('excel')) return 'Spreadsheet';
  if (mimeType.includes('presentation') || mimeType.includes('powerpoint')) return 'Presentation';
  if (mimeType === 'application/zip' || mimeType.includes('compressed')) return 'Archive';
  if (mimeType === 'text/plain') return 'Text';
  if (mimeType === 'text/csv') return 'CSV';
  
  return 'File';
}
